<div class="app-legend">
  <h3 i18n>BOX</h3>
  <p *ngFor="let item of boxs">
    <svg width="20px" height="20px" opacity="0.7">
      <polygon fill="none" [attr.stroke]="item.color" stroke-width="2px" points="5,2 15,2 18,10 15,18 5,18 2,10" />
    </svg>
    {{item.name}}
  </p>
</div>
<div class="app-legend">
  <h3 i18n>VERTEX</h3>
  <p *ngFor="let item of vertexes">
    <svg width="20px" height="20px" opacity="0.7">
      <circle cy="10" cx="10" fill-opacity="0" [attr.stroke]="item.color" stroke-width="2" r="8" />
    </svg>
    {{item.name}}
  </p>
</div>
<div class="app-legend">
  <h3 i18n>CABLE</h3>
  <p *ngFor="let item of cables">
    <svg width="20px" height="20px" opacity="0.7">
      <line x1="0" y1="10" x2="20" y2="10" [attr.stroke]="item.color" stroke-width="5" />
    </svg>
    {{item.name}}
  </p>
</div>
